import "./product-form";
import "./product-upsell/product-upsell";
import "./dl-view-item";
import "./product-page-morph";
import "./media-gallery";
import "./zoom-gallery";
import "./size-guide/size-guide-link";

import { saveData, getData } from "../helpers/recentlyViewed";

const MAX_PRODUCTS = 6;

let currentProductSaved = false;

class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.data = getData();

    const currentProductData = JSON.parse(
      this.querySelector("[data-current-product-data]").innerHTML,
    );

    currentProductData.savedAt = Date.now();

    this._refresh = () => {
      this.data = getData();
    };

    this.data.unshift(currentProductData);

    this.data = this.data
      // Filter to remove duplicates
      .filter(
        ({ handle }, i, items) =>
          items.findIndex((item) => handle === item.handle) === i,
      )
      .slice(0, MAX_PRODUCTS);

    try {
      if (!currentProductSaved) {
        saveData(this.data);
        currentProductSaved = true;
      }
    } catch (error) {
      console.warn("Error saving recently viewed products", error);
    }
  }

  connectedCallback() {
    document.addEventListener("recently-viewed:refreshed", this._refresh);
  }

  disconnectedCallback() {
    document.removeEventListener("recently-viewed:refreshed", this._refresh);
  }
}

if (!customElements.get("main-product")) {
  customElements.define("main-product", MainProduct);
}
